import moment from "moment";
import { isEmpty } from "@/helpers/core";

export function setCookie(cname, cvalue, expireAt) {
  if (isEmpty(expireAt)) {
    document.cookie = `${cname}=${cvalue};path=/;SameSite=Strict;`;
  } else {
    document.cookie = `${cname}=${cvalue};expires=${moment(expireAt).toDate().toUTCString()};path=/;SameSite=Strict;`;
  }
}

export function getCookie(cname) {
  const name = `${cname}=`;
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
